/**
 * CDPH-6572: HTTP failures on MaintenanceFlag (expired POP/guest token, 5xx,
 * SQL timeouts, network) are not real maintenance.
 *
 * The maintenance banner must only appear when the PA asset notes field is
 * explicitly "true" (UI/API deployment or PA asset activation).
 */
export function failOpenMaintenanceMode(setInMaintenanceMode, setIsErrorFetchingMaintenanceText) {
  if (typeof setInMaintenanceMode === "function") {
    setInMaintenanceMode(false)
  }
  if (typeof setIsErrorFetchingMaintenanceText === "function") {
    setIsErrorFetchingMaintenanceText(false)
  }
}
